'use client';

import styles from '@/components/audit/ProReportResults.module.css';

interface PrinciplesSummaryProps {
  principles: string[];
}

export function PrinciplesSummary({ principles }: PrinciplesSummaryProps) {
  if (principles.length === 0) return null;

  return (
    <section className={styles.principlesSection}>
      <h2 className={styles.sectionTitle}>Principles Evaluated</h2>
      <p className={styles.principlesIntro}>
        Your site was analyzed against these established UX/UI principles:
      </p>
      <div className={styles.principlesTags}>
        {principles.map((principle) => (
          <span key={principle} className={styles.principleTag}>
            {principle}
          </span>
        ))}
        {principles.length === 12 && (
          <span className={styles.principleTagMore}>+{167 - 12} more</span>
        )}
      </div>
    </section>
  );
}
